<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard class="notification-card">
          <CCardHeader class="notification-header">
            <div class="header-wrapper">
              <div class="header-left">
                <!-- Bell SVG Icon -->
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="header-icon">
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
                <strong class="header-title">{{ $t('notification_center') }}</strong>
                <span class="notification-badge">{{ getTotalNotifications }}</span>
              </div>
              <div class="header-right">
              </div>
            </div>
          </CCardHeader>

          <CCardBody class="notification-body">
            <CTabs class="custom-tabs">
              <CTab title="پیامک" class="tab-content-wrapper">
                <CRow v-if="user_info.send_sms != null" class="notification-row">
                  <CCol cols="12">
                    <div class="notification-section">
                      <!-- SMS Usage Card -->
                      <div class="usage-card">
                        <div class="usage-icon">
                          <!-- SMS SVG Icon -->
                          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                          </svg>
                        </div>
                        <div class="usage-info">
                          <span class="usage-label">مصرف پیامک</span>
                          <span class="usage-value">{{ get_currency(user_info.sms_usage) }}</span>
                        </div>
                      </div>

                      <hr class="section-divider">

                      <!-- SMS Status Card -->
                      <div class="status-card">
                        <div class="status-header">
                          <span class="status-label">وضعیت ارسال پیامک</span>
                        </div>

                        <div v-if="user_info.send_sms == 1" class="status-active">
                          <div class="status-badge success">
                            <!-- Check SVG -->
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                              <polyline points="20 6 9 17 4 12" />
                            </svg>
                            فعال
                          </div>
                          <CButton color="success" class="status-toggle-btn" @click="update_my_profile_send_sms(0)">
                            تغییر وضعیت
                          </CButton>
                          <div class="status-description success">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <circle cx="12" cy="12" r="10" />
                              <path d="M12 16v-4" />
                              <path d="M12 8h.01" />
                            </svg>
                            <span>
                              اعلانات پیامکی شما
                              <span class="font-weight-bold text-success">فعال</span>
                              است و پیامک رزرو، کنسلی و لیست انتظار برای شما ارسال می‌گردد
                            </span>
                          </div>
                        </div>

                        <div v-if="user_info.send_sms == 0" class="status-inactive">
                          <div class="status-badge danger">
                            <!-- X SVG -->
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                              <line x1="18" y1="6" x2="6" y2="18" />
                              <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                            غیرفعال
                          </div>
                          <CButton color="danger" class="status-toggle-btn" @click="update_my_profile_send_sms(1)">
                            تغییر وضعیت
                          </CButton>
                          <div class="status-description danger">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <circle cx="12" cy="12" r="10" />
                              <line x1="12" y1="8" x2="12" y2="12" />
                              <line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            <span>
                              اعلانات پیامکی شما
                              <span class="font-weight-bold text-danger">غیرفعال</span>
                              است و پیامک رزرو، کنسلی و لیست انتظار برای شما ارسال نمی‌گردد
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CTab>

              <CTab title="تلگرام" class="tab-content-wrapper">
                <CRow v-if="telegram_code.telegram_code != null" class="notification-row">
                  <CCol cols="12">
                    <div class="notification-section">
                      <!-- Telegram Setup Card -->
                      <div class="setup-card">
                        <div class="setup-icon">
                          <!-- Telegram SVG -->
                          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#0088cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.5 4.5L2.5 10.5L9.5 14.5L13.5 21.5L21.5 4.5Z" />
                            <path d="M9.5 14.5L12.5 18.5L15.5 10.5" />
                          </svg>
                        </div>

                        <div class="setup-content">
                          <div class="setup-step">
                            <div class="step-number">1</div>
                            <div class="step-text">
                              <span class="step-label">ربات زیر را در تلگرام خود اضافه کنید</span>
                              <div class="bot-name" :class="$i18n.locale == 'en' ? 'ltr' : 'rtl'">
                                {{ $i18n.locale == 'en' ? '@bookmeto_bot' : '@rezerveto_bot' }}
                              </div>
                            </div>
                          </div>

                          <hr class="section-divider">

                          <div class="setup-step">
                            <div class="step-number">2</div>
                            <div class="step-text">
                              <span class="step-label">کد زیر را در ربات وارد کنید تا اتصال شما برقرار شود</span>
                              <div class="code-wrapper">
                                <span id="telegram_code_root" class="code-display">{{ telegram_code.telegram_code }}</span>
                                <CButton size="sm" class="copy-btn" color="primary" @click="copy_telegram_code()">
                                  <!-- Copy SVG -->
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                  </svg>
                                </CButton>
                              </div>
                            </div>
                          </div>

                          <hr class="section-divider">

                          <div class="setup-step">
                            <div class="step-number">3</div>
                            <div class="step-text">
                              <span class="step-label">وضعیت اتصال</span>
                              <div class="connection-status">
                                <div v-if="telegram_code.telegram_enabled" class="status-connected">
                                  <span class="status-dot connected"></span>
                                  {{ $t('connected') }}
                                </div>
                                <div v-else class="status-disconnected">
                                  <span class="status-dot disconnected"></span>
                                  {{ $t('disconnect') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CTab>

              <CTab title="بله" class="tab-content-wrapper">
                <CRow v-if="bale_code.telegram_code != null" class="notification-row">
                  <CCol cols="12">
                    <div class="notification-section">
                      <!-- Bale Setup Card -->
                      <div class="setup-card bale">
                        <div class="setup-icon bale-icon">
                          <!-- Bale SVG (Custom) -->
                          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#00b894" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M8 12l2 2 6-6" />
                          </svg>
                        </div>

                        <div class="setup-content">
                          <div class="setup-step">
                            <div class="step-number bale-step">1</div>
                            <div class="step-text">
                              <span class="step-label">ربات زیر را در پیامرسان بله خود اضافه کنید</span>
                              <div class="bot-name">@rezerveto_bot</div>
                            </div>
                          </div>

                          <hr class="section-divider">

                          <div class="setup-step">
                            <div class="step-number bale-step">2</div>
                            <div class="step-text">
                              <span class="step-label">کد زیر را در ربات وارد کنید تا اتصال شما برقرار شود</span>
                              <div class="code-wrapper">
                                <span id="bale_code_root" class="code-display">{{ bale_code.telegram_code }}</span>
                                <CButton size="sm" class="copy-btn" color="primary" @click="copy_bale_code()">
                                  <!-- Copy SVG -->
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                  </svg>
                                </CButton>
                              </div>
                            </div>
                          </div>

                          <hr class="section-divider">

                          <div class="setup-step">
                            <div class="step-number bale-step">3</div>
                            <div class="step-text">
                              <span class="step-label">{{ $t('telegram_connection_status') }}</span>
                              <div class="connection-status">
                                <div v-if="bale_code.telegram_enabled" class="status-connected">
                                  <span class="status-dot connected"></span>
                                  {{ $t('connected') }}
                                </div>
                                <div v-else class="status-disconnected">
                                  <span class="status-dot disconnected"></span>
                                  {{ $t('disconnect') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'NotificationCenter',
  components: {},
  data() {
    return {
      telegram_code: {},
      bale_code: {},
      user_info: {}
    }
  },
  computed: {
    getTotalNotifications() {
      let count = 0;
      if (this.user_info.send_sms !== undefined) count++;
      if (this.telegram_code.telegram_code) count++;
      if (this.bale_code.telegram_code) count++;
      return count;
    },

  },
  mounted() {
    this.get_user_info();
    this.get_telegram_info();
    this.get_bale_info();
  },
  methods: {
    copy_telegram_code() {
      const text = document.getElementById('telegram_code_root').innerText;
      navigator.clipboard.writeText(text)
          .then(() => {
            this.showToast('کد با موفقیت کپی شد!', 'success');
          })
          .catch(() => {
            this.showToast('خطا در کپی کد', 'error');
          });
    },
    copy_bale_code() {
      const text = document.getElementById('bale_code_root').innerText;
      navigator.clipboard.writeText(text)
          .then(() => {
            this.showToast('کد با موفقیت کپی شد!', 'success');
          })
          .catch(() => {
            this.showToast('خطا در کپی کد', 'error');
          });
    },
    showToast(message, type) {
      var res = {
        data: {
          error: type === 'success' ? 0 : 1,
          msg: message
        }
      };
      this.$root.modal_component.show_api_response_modals(res);
    },
    get_telegram_info() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/site/generate_telegram_bot_code', formData, {})
          .then(function (response) {
            self.telegram_code = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    get_user_info() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/user/get_my_profile', formData, {})
          .then(function (response) {
            self.user_info = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    update_my_profile_send_sms(status) {
      var self = this;
      var formData = new FormData();
      formData.append('status', status);
      axios.post('/api/admin/user/update_my_profile_send_sms', formData, {})
          .then(function (response) {
            self.user_info = response.data;
            self.showToast('وضعیت پیامک با موفقیت تغییر کرد!', 'success');
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    get_bale_info() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/site/generate_bale_bot_code', formData, {})
          .then(function (response) {
            self.bale_code = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
    }
  }
}
</script>

<style scoped>
/* Main Card */
.notification-card {
  border-radius: 16px;
  box-shadow: 0 2px 24px rgba(0,0,0,0.06);
  overflow: hidden;
  border: none;
}

/* Header */
.notification-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px 24px;
  border-bottom: none;
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
}

.header-icon {
  stroke: white;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.notification-badge {
  background: rgba(255,255,255,0.25);
  color: white;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.header-right {
  color: rgba(255,255,255,0.8);
  font-size: 12px;
}

.last-update {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Body */
.notification-body {
  padding: 24px;
  background: #f8f9fa;
}

/* Custom Tabs */
.custom-tabs >>> .nav-tabs {
  border-bottom: 2px solid #e9ecef;
  gap: 4px;
}

.custom-tabs >>> .nav-tabs .nav-link {
  border: none;
  padding: 12px 24px;
  color: #6c757d;
  font-weight: 500;
  border-radius: 8px 8px 0 0;
  transition: all 0.3s ease;
}

.custom-tabs >>> .nav-tabs .nav-link:hover {
  color: #667eea;
  background: rgba(102, 126, 234, 0.05);
}

.custom-tabs >>> .nav-tabs .nav-link.active {
  color: #667eea;
  background: white;
  border-bottom: 3px solid #667eea;
  font-weight: 600;
}

.tab-content-wrapper {
  padding: 20px 0;
}

/* Notification Section */
.notification-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}

.notification-row {
  margin: 0;
}

/* Usage Card */
.usage-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  margin-bottom: 16px;
}

.usage-icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.usage-icon svg {
  stroke: #667eea;
}

.usage-info {
  display: flex;
  flex-direction: column;
}

.usage-label {
  font-size: 13px;
  color: #6c757d;
}

.usage-value {
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
}

/* Section Divider */
.section-divider {
  margin: 20px 0;
  border-color: #e9ecef;
}

/* Status Card */
.status-card {
  padding: 4px 0;
}

.status-header {
  margin-bottom: 16px;
}

.status-label {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
}

.status-badge.success {
  background: #d4edda;
  color: #155724;
}

.status-badge.danger {
  background: #f8d7da;
  color: #721c24;
}

.status-badge svg {
  stroke: currentColor;
}

.status-toggle-btn {
  border-radius: 8px;
  padding: 8px 20px;
  font-size: 13px;
  margin-right: 12px;
}

.status-description {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  margin-top: 12px;
  font-size: 14px;
  line-height: 1.6;
}

.status-description.success {
  background: #f0fdf4;
  color: #166534;
}

.status-description.danger {
  background: #fef2f2;
  color: #991b1b;
}

.status-description svg {
  flex-shrink: 0;
  margin-top: 2px;
}

/* Setup Card */
.setup-card {
  padding: 8px 0;
}

.setup-card.bale .setup-icon {
  background: #f0fdf4;
}

.setup-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: #f0f7ff;
  border-radius: 16px;
  margin-bottom: 20px;
}

.bale-icon svg {
  stroke: #00b894;
}

.setup-step {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.step-number {
  width: 32px;
  height: 32px;
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 50%;
  font-weight: 700;
  font-size: 14px;
}

.bale-step {
  background: linear-gradient(135deg, #00b894 0%, #00a381 100%);
}

.step-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.step-label {
  font-size: 14px;
  color: #2d3748;
  font-weight: 500;
}

.bot-name {
  font-size: 16px;
  font-weight: 600;
  color: #667eea;
  padding: 6px 12px;
  background: #f0f7ff;
  border-radius: 6px;
  display: inline-block;
  direction: ltr;
}

.bot-name.rtl {
  direction: rtl;
}

.code-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.code-display {
  font-family: 'Courier New', monospace;
  font-size: 18px;
  font-weight: 700;
  padding: 8px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
  color: #2d3748;
  letter-spacing: 2px;
  user-select: all;
}

.copy-btn {
  padding: 4px 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.copy-btn svg {
  stroke: white;
}

/* Connection Status */
.connection-status {
  margin-top: 4px;
}

.status-connected,
.status-disconnected {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
}

.status-connected {
  background: #d4edda;
  color: #155724;
}

.status-disconnected {
  background: #f8d7da;
  color: #721c24;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.status-dot.connected {
  background: #28a745;
  animation: pulse-dot 2s infinite;
}

.status-dot.disconnected {
  background: #dc3545;
}

@keyframes pulse-dot {
  0% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(1.2); }
  100% { opacity: 1; transform: scale(1); }
}

/* Responsive */
@media (max-width: 768px) {
  .notification-header {
    padding: 16px;
  }

  .header-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .header-right {
    width: 100%;
    font-size: 11px;
  }

  .notification-body {
    padding: 16px;
  }

  .notification-section {
    padding: 16px;
  }

  .usage-card {
    flex-direction: column;
    text-align: center;
  }

  .setup-step {
    flex-direction: column;
    align-items: stretch;
  }

  .step-number {
    align-self: flex-start;
  }

  .code-display {
    font-size: 14px;
    padding: 6px 12px;
  }

  .status-toggle-btn {
    width: 100%;
    margin: 8px 0;
  }

  .status-badge {
    display: inline-flex;
  }

  .status-description {
    font-size: 13px;
    flex-direction: column;
  }

  .custom-tabs >>> .nav-tabs .nav-link {
    padding: 10px 16px;
    font-size: 13px;
  }
}

/* Tablet */
@media (min-width: 769px) and (max-width: 1024px) {
  .notification-section {
    padding: 20px;
  }
}

/* LTR Support */
.ltr {
  direction: ltr !important;
}

.rtl {
  direction: rtl !important;
}
</style>